import { useRouter } from 'next/router'
import Container from '../../components/container';
import fetch from "isomorphic-fetch";
import config from "../../config.json";
import UnitMinimum from "../../components/unit-minimum";
import Masonry from "react-masonry-css";
import Pagination from "../../components/pagination";
import Whatsapp from "../../components/whatsapp";

const Product = ({data, menu})=>{
    const router = useRouter();
    const getItems = () => {
      return data.data.map(i=>{
         return <UnitMinimum key={i.id_producto} data={i}/>
      });
    }
    return (
        <>
            <Container title={`Envio de arreglos florales, Florería Detalles y Caprichos`} menu={menu} noNewsletter={true}>
                <Masonry
                    breakpointCols={{
                        default: 3,
                        1200: 3,
                        942: 2,
                        622: 1
                    }}
                    className="my-masonry-grid marginBottom"
                    columnClassName="my-masonry-grid_column">
                    {getItems()}
                </Masonry>
                <Pagination total={data.pagination.pages}
                            page={data.pagination.page}
                            path="/floreria-cdmx-edomex?pagina="
                            maxpages={data.pagination.pages}
                />
            </Container>
            <Whatsapp/>
        </>
    );
};

export async function getServerSideProps({query}){
    const page = (query?.pagina) ? query.pagina : 1;
    const res = await fetch(`${config.api.uri}/v1/product/price/${query.city}?apikey=${config.api.apikey}&page=${page}&perpage=${config.pagination.perpage}`);
    const resJSON = await res.json();
    const resMenu = await fetch(`${config.api.uri}/v1/cat/menu/1?apikey=${config.api.apikey}`);
    const resJSONMenu = await resMenu.json();
    if(res.status === 404){
        const resRedirect = await fetch(`${config.api.uri}/v1/general/redirect-indices/${query.city}?apikey=${config.api.apikey}`);
        const JSONRedirect = await resRedirect.json();
        if(JSONRedirect.uri){
            return {
                redirect: {
                    permanent: true,
                    destination: `/floreria-cdmx-edomex/${JSONRedirect.uri}`
                }
            }
        }else{
            return {
                notFound: true
            }
        }

    }else{
        if(resJSON.error){
            return {
                notFound: true
            }
        }else{
            return {
                props: {
                    data: resJSON,
                    menu: resJSONMenu
                }
            }
        }
    }
}

export default Product;
